{
    "Profile_Summary_Recap.taxesIncluded": "{estimatedAnnualGross} (taxes included)",
    "Profile_Summary_Recap.savings": "You could save {estimatedAnnualPremium} annually ({estimatedMonthlyGross} monthly)",
    "Profile_Summary_Recap.downloadBinder": "Download Binder"
}
